import styled from 'styled-components'

import { helpers } from '../../../styles/theme'

export const Link = styled.a`
	color: ${helpers.color.link};
	text-decoration: none;
	font-size: 14px;
`
